<template>
  <div>
    <div class="black-overlay"></div>
    <div class="modal modal--welcomeback modal--unsubscribe" id="unsubscribe_modal">
      <div class="modal__content">
        <button class="btn modal-close"><i class="icon-close"></i></button>
        <div class="modal__header">
          <h1>{{ userDetails.username }}, {{ getTranslations.home_modals_unsubscribe_choice_in_level }}</h1>
          <img :src="getTranslations.project_config_modal_img" alt="">
        </div>
        <div class="modal__body">
          {{ getTranslations.home_modals_unsubscribe_choice_if_you }}
        </div>
        <div class="modal__footer">
          <a class="btn2 btn2--small btn2--outline" @click="unsubscribe" style="cursor:pointer">
              {{ getTranslations.home_modals_unsubscribe_choice_unsubscribe }}
          </a>
          <a class="btn2 btn2--std btn2--small" @click="noUnSubscribe" style="cursor:pointer">
              {{ getTranslations.home_modals_unsubscribe_choice_cancel }}
          </a>
        </div>
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
  /* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }] */
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
import IntegrationMixin from '@/common/mixins/integration';
import modals from '../../../common/modals';
import Resubscribe from './Resubscribe';
import UnsubscribeSms from './UnsubscribeSms';
import ResubscribeQuestionViaSms from './ResubscribeQuestionViaSms';

export default {
  // modal_unsubscribe.html
  name: 'unsubscribe',
  mixins: [IntegrationMixin],
  components: {
    Resubscribe,
    UnsubscribeSms,
    ResubscribeQuestionViaSms,
  },
  methods: {
    ...mapMutations('common', [
      'storeModalForSettings',
    ]),
    ...mapActions('profile', [
      'getUserLoginDetails',
    ]),
    ...mapActions('common', [
      'optoutCall',
    ]),
    noUnSubscribe() {
      modals.hideModal(this);
    },
    unsubSms() {
      const activeIntegration = this.getIntegrationByName();
      return activeIntegration && activeIntegration.value.unsubWithSms;
    },
    unsubscribe() {
      if (this.unsubSms()) {
        this.storeModalForSettings(UnsubscribeSms);
        modals.showHideModal(this);
      } else {
        this.optoutCall().then(() => {
          this.getUserLoginDetails().then(() => {
            if (this.userDetails.subscribed) {
              modals.hideModal(this);
            } else {
              if (this.subAndUnsubViaSMS && (this.reoptinAndOptoutConfig === 'REOPTIN_SMS' || this.reoptinAndOptoutConfig === 'REOPTIN_OPTOUT_SMS')) {
                this.storeModalForSettings(ResubscribeQuestionViaSms);
              } else {
                this.storeModalForSettings(Resubscribe);
              }
              modals.showHideModal(this);
            }
          });
        });
      }
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
      'subAndUnsubViaSMS',
      'reoptinAndOptoutConfig',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>

<style type="text/css">
  a {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/modals/Unsubscribe.vue